import {InertiaLink} from '@inertiajs/inertia-react';
import cx from 'classnames';
import React, {useState} from 'react';

import {Button, ButtonSize, ButtonType} from '../../components/crousal/Button';
import {H1} from '../../components/crousal/Headings';
import {TextInput} from '../../components/crousal/TextInput';
import {SelectInput} from '../../components/crousal/SelectInput';
import {getParsedQueryString} from '../../components/utils/url';
import styled from "styled-components";
import {IRegions} from '../../common/types/RegionsAndRanks';
import {Inertia} from "@inertiajs/inertia";

const RegisterBackgroundImage = styled.div`
 background: url('/images/unrankedsmurfs-login/mobile_loginbg.png');
 background-size: cover;

@media (min-width: 1024px) {
  background: url('/images/unrankedsmurfs-login/login_bg.png');
  background-size: cover;
  }
`;

type Fields =
    | 'name'
    | 'email'
    | 'email_confirmation'
    | 'password'
    | 'password_confirmation'
    | 'region';

interface IProps {
    errors: Record<Fields, string>;
    oldInput: Record<Fields, string>;
    regions: IRegions[];
}

export function Register({errors, oldInput, regions}: IProps) {
    const [name, setName] = useState(oldInput?.name ?? '');
    const [email, setEmail] = useState(oldInput?.email ?? '');
    const [password, setPassword] = useState(oldInput?.password ?? '');
    const [passwordConfirmation, setPasswordConfirmation] = useState(
        oldInput?.password_confirmation ?? '',
    );

    const [region, setRegion] = useState(oldInput?.region ?? '');
    const {next} = getParsedQueryString();
    const nextRedirectQS = next ? `?next=${next}` : '';

    const confirmationDoesntMatch =
        password && passwordConfirmation && password !== passwordConfirmation
            ? 'The password confirmation does not match.'
            : undefined;

    function handleRegister() {
        Inertia.post(`/register${nextRedirectQS}`, {
            name,
            email,
            password,
            password_confirmation: passwordConfirmation,
            region_id: region,
        });
    }

    return (
        <RegisterBackgroundImage className="h-screen">
            <div className="h-full flex relative">
                <div className={cx('w-full lg:w-3/5 bg-gray-100', 'pt-100 lg:pt-200')}>
                    <div className="w-4/5 md:w-1/2 xl:w-1/3 mx-auto mt-6">
                        <img src={"/images/unrankedsmurfs-login/login_shield.png"} alt={"shield image"}/>
                        <H1 className="text-smurfs-gold">Register</H1>

                        <TextInput
                            placeholder={"Name"}
                            value={name}
                            onChange={setName}
                            className="mt-4"
                            error={errors.name}
                        />

                        <TextInput
                            placeholder={"Email Address"}
                            value={email}
                            onChange={setEmail}
                            className="mt-4"
                            error={errors.email}
                        />

                        <TextInput
                            placeholder={"Password"}
                            type="password"
                            value={password}
                            onChange={setPassword}
                            className="mt-4"
                            error={confirmationDoesntMatch ? '' : errors.password}
                        />

                        <TextInput
                            placeholder={"Password Confirmation"}
                            type="password"
                            value={passwordConfirmation}
                            onChange={setPasswordConfirmation}
                            className="mt-4"
                            error={confirmationDoesntMatch ?? errors.password}
                        />

                        <SelectInput
                            value={region}
                            onChange={setRegion}
                            options={regions}
                            placeholder="Preferred Lol Server"
                            className="mt-4"
                            error={errors.region}
                        />

                        <InertiaLink
                            href="/login"
                            className="block font-ubuntu font-bold text-14 uppercase mt-4 text-london-air-white"
                        >
                            Already have an account?
                        </InertiaLink>

                        <div className="flex mt-4 w-full">
                            <Button
                                type={ButtonType.DEFAULT}
                                size={ButtonSize.DEFAULT}
                                onClick={handleRegister}
                            >
                                Register
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </RegisterBackgroundImage>
    );
}
